/* Copyright (c) 2026 Xperi. All Rights Reserved. */

import { Carousel, Carousels, OfferType } from 'client-code/wrs-feed-service';

import { WrsFeedServiceRepositoryImpl } from '../impls/WrsFeedServiceRepositoryImpl';
import { IWrsFeedService, IWrsFeedServiceRepository } from '../interfaces';
import { TServicesParams } from '../types';

export class WrsFeedService implements IWrsFeedService {
    private wrsFeedServiceRepository: IWrsFeedServiceRepository;

    public constructor(params: TServicesParams) {
        this.wrsFeedServiceRepository = new WrsFeedServiceRepositoryImpl(params);
    }

    public async fetchScreen(
        screenName: string,
        adUnitsSupported?: Array<string>,
        count?: number,
        initialFeedItemCount?: number,
        includeAdult?: boolean,
        includeIpVod?: boolean,
        includeSportsPass?: boolean,
        pageCursor?: string,
    ): Promise<Carousels> {
        return this.wrsFeedServiceRepository.getScreen(
            screenName,
            adUnitsSupported,
            count,
            initialFeedItemCount,
            includeAdult,
            includeIpVod,
            includeSportsPass,
            pageCursor,
        );
    }

    public async fetchCarousel(
        carouselName: string,
        offset?: number,
        count?: number,
        includeAdult?: boolean,
        includeIpVod?: boolean,
        includeSportsPass?: boolean,
    ): Promise<Carousel> {
        return this.wrsFeedServiceRepository.getCarousel(
            carouselName,
            offset,
            count,
            includeAdult,
            includeIpVod,
            includeSportsPass,
        );
    }

    public async addWatchHistory(
        objectType: OfferType,
        objectId: string,
        collectionId?: string,
    ): Promise<void> {
        return this.wrsFeedServiceRepository.postWatchHistory(objectType, objectId, collectionId);
    }
}
